var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description"},[_c('rich-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.ctrl.display),expression:"ctrl.display"}],staticClass:"desc",attrs:{"text":_vm.label,"align":_vm.align,"labelStyle":_vm.style}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }